var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "more-about-yourself-step" },
    [
      _c("p", { staticClass: "fm-section-label" }, [
        _vm._v("Personal Details"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-md-4" },
          [
            _c(
              "FormGroup",
              {
                attrs: {
                  "error-container": _vm.errorContainerName,
                  label: "First Name",
                  name: "firstName",
                  floating: true,
                },
              },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.firstName,
                      expression: "form.firstName",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { name: "firstName", type: "text", placeholder: " " },
                  domProps: { value: _vm.form.firstName },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.form, "firstName", $event.target.value)
                    },
                  },
                }),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-md-4" },
          [
            _c(
              "FormGroup",
              { attrs: { label: "Middle Name", floating: true } },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.middleName,
                      expression: "form.middleName",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { name: "middleName", type: "text", placeholder: " " },
                  domProps: { value: _vm.form.middleName },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.form, "middleName", $event.target.value)
                    },
                  },
                }),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-md-4" },
          [
            _c(
              "FormGroup",
              {
                attrs: {
                  "error-container": _vm.errorContainerName,
                  label: "Last Name",
                  name: "lastName",
                  floating: true,
                },
              },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.lastName,
                      expression: "form.lastName",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { name: "lastName", type: "text", placeholder: " " },
                  domProps: { value: _vm.form.lastName },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.form, "lastName", $event.target.value)
                    },
                  },
                }),
              ]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-md-4" },
          [
            _c("GenderSelect", {
              attrs: {
                "error-container": _vm.errorContainerName,
                floating: true,
              },
              model: {
                value: _vm.form.gender,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "gender", $$v)
                },
                expression: "form.gender",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-md-4" },
          [
            _c(
              "FormGroup",
              {
                attrs: {
                  "error-container": _vm.errorContainerName,
                  label: "Date of Birth",
                  name: "dob",
                  floating: true,
                },
              },
              [
                _c("calendar-input", {
                  attrs: { name: "dob" },
                  model: {
                    value: _vm.form.dob,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "dob", $$v)
                    },
                    expression: "form.dob",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-md-4" },
          [
            _c("MaritalStatusSelect", {
              attrs: { errorContainer: _vm.errorContainerName, floating: true },
              model: {
                value: _vm.form.maritalStatus,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "maritalStatus", $$v)
                },
                expression: "form.maritalStatus",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-md-4" },
          [
            _c("NumberOfDependentsSelect", {
              attrs: {
                "error-container": _vm.errorContainerName,
                floating: true,
              },
              model: {
                value: _vm.form.numberOfDependents,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "numberOfDependents", $$v)
                },
                expression: "form.numberOfDependents",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-md-8" },
          [
            _c("ResidentialStatusSelect", {
              attrs: {
                "error-container": _vm.errorContainerName,
                floating: true,
              },
              model: {
                value: _vm.form.residentialStatus,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "residentialStatus", $$v)
                },
                expression: "form.residentialStatus",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "fm-info-box" },
        [
          _c("Checkbox", {
            attrs: {
              "error-container": _vm.errorContainerName,
              name: "australianResident",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ onClick }) {
                  return [
                    _c("div", { on: { click: onClick } }, [
                      _vm._v(
                        "I am an Australian Citizen or Permanent Resident of Australia."
                      ),
                    ]),
                  ]
                },
              },
            ]),
            model: {
              value: _vm.form.australianResident,
              callback: function ($$v) {
                _vm.$set(_vm.form, "australianResident", $$v)
              },
              expression: "form.australianResident",
            },
          }),
          _vm._v(" "),
          _c("p", { staticClass: "fm-section-label mt-3" }, [
            _vm._v("Medicare Information"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-md-6" },
              [
                _c(
                  "FormGroup",
                  {
                    attrs: {
                      "error-container": _vm.errorContainerName,
                      label: "Medicare Card Number",
                      name: "medicare.number",
                      floating: true,
                    },
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.medicare.number,
                          expression: "form.medicare.number",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: {
                        name: "medicareCardNumber",
                        type: "text",
                        placeholder: " ",
                      },
                      domProps: { value: _vm.form.medicare.number },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.form.medicare,
                            "number",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-md-6" },
              [
                _c(
                  "FormGroup",
                  {
                    attrs: {
                      "error-container": _vm.errorContainerName,
                      label: "Medicare Reference Number",
                      name: "medicare.reference",
                      floating: true,
                    },
                  },
                  [
                    _c("FmSelect", {
                      attrs: {
                        value: _vm.form.medicare.reference,
                        options: _vm.medicareReferenceOptions,
                        icons: _vm.medicareRefIcons,
                      },
                      on: {
                        input: function ($event) {
                          _vm.form.medicare.reference =
                            $event !== "" ? Number($event) : null
                        },
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-4" }, [
              _c(
                "div",
                { staticClass: "fm-expiry-group" },
                [
                  _c(
                    "label",
                    {
                      staticClass: "fm-expiry-group__label",
                      attrs: { id: "medicare-color-label" },
                    },
                    [_vm._v("Card Colour")]
                  ),
                  _vm._v(" "),
                  _c("RadioButtonGroup", {
                    attrs: {
                      block: true,
                      options: { G: "Green", B: "Blue", Y: "Yellow" },
                      name: "medicareCardColor",
                      size: "sm",
                      type: "outline-secondary",
                      "aria-labelledby": "medicare-color-label",
                    },
                    model: {
                      value: _vm.form.medicare.color,
                      callback: function ($$v) {
                        _vm.$set(_vm.form.medicare, "color", $$v)
                      },
                      expression: "form.medicare.color",
                    },
                  }),
                  _vm._v(" "),
                  _c("ErrorText", {
                    attrs: {
                      errorContainer: _vm.errorContainerName,
                      name: "medicare.color",
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-4" }, [
              _c("div", { staticClass: "fm-expiry-group" }, [
                _c("label", { staticClass: "fm-expiry-group__label" }, [
                  _vm._v("Medicare Middle Name"),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.medicare.middleName,
                      expression: "form.medicare.middleName",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { name: "medicareMiddleName", type: "text" },
                  domProps: { value: _vm.form.medicare.middleName },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.form.medicare,
                        "middleName",
                        $event.target.value
                      )
                    },
                  },
                }),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-4" }, [
              _c(
                "div",
                { staticClass: "fm-expiry-group" },
                [
                  _c("label", { staticClass: "fm-expiry-group__label" }, [
                    _vm._v("Medicare Expiry"),
                  ]),
                  _vm._v(" "),
                  _c("MedicareExpiryDateInput", {
                    attrs: { color: _vm.form.medicare.color },
                    model: {
                      value: _vm.form.medicare.expiry,
                      callback: function ($$v) {
                        _vm.$set(_vm.form.medicare, "expiry", $$v)
                      },
                      expression: "form.medicare.expiry",
                    },
                  }),
                  _vm._v(" "),
                  _c("ErrorText", {
                    attrs: {
                      errorContainer: _vm.errorContainerName,
                      name: "medicare.expiry",
                    },
                  }),
                ],
                1
              ),
            ]),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("p", { staticClass: "fm-section-label mt-1" }, [
        _vm._v("Current Address"),
      ]),
      _vm._v(" "),
      _c("AddressInput", {
        attrs: {
          "error-container": _vm.errorContainerName,
          "error-key-prefix": "addresses.current.",
          name: "Current Address",
        },
        model: {
          value: _vm.form.addresses.current,
          callback: function ($$v) {
            _vm.$set(_vm.form.addresses, "current", $$v)
          },
          expression: "form.addresses.current",
        },
      }),
      _vm._v(" "),
      _c(
        "SmoothReflow",
        { attrs: { show: _vm.isPreviousAddressRequired } },
        [
          _c("AddressInput", {
            attrs: {
              duration: false,
              "error-container": _vm.errorContainerName,
              "error-key-prefix": "addresses.previous.",
              name: "Previous Address",
            },
            scopedSlots: _vm._u([
              {
                key: "header-text",
                fn: function () {
                  return [
                    _c(
                      "div",
                      { staticClass: "fm-alert fm-alert--warning mb-3" },
                      [
                        _c(
                          "svg",
                          {
                            staticClass: "fm-alert__icon",
                            attrs: {
                              fill: "currentColor",
                              viewBox: "0 0 16 16",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z",
                              },
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                d: "M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z",
                              },
                            }),
                          ]
                        ),
                        _vm._v(
                          "\n          Previous address required — current address is less than 1 year.\n        "
                        ),
                      ]
                    ),
                  ]
                },
                proxy: true,
              },
            ]),
            model: {
              value: _vm.form.addresses.previous,
              callback: function ($$v) {
                _vm.$set(_vm.form.addresses, "previous", $$v)
              },
              expression: "form.addresses.previous",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("p", { staticClass: "fm-section-label mt-1" }, [
        _vm._v("Identity Verification"),
      ]),
      _vm._v(" "),
      _c("IDVerificationSelect", {
        attrs: {
          "error-container": _vm.errorContainerName,
          name: "idVerification.documentType",
          floating: true,
        },
        model: {
          value: _vm.form.idVerification.documentType,
          callback: function ($$v) {
            _vm.$set(_vm.form.idVerification, "documentType", $$v)
          },
          expression: "form.idVerification.documentType",
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          {
            class: `col-md-${
              _vm.form.idVerification.documentType === "passport" ? 6 : 4
            }`,
          },
          [
            _vm.form.idVerification.documentType === "passport"
              ? _c(
                  "FormGroup",
                  {
                    attrs: {
                      "error-container": _vm.errorContainerName,
                      label: "Passport Number",
                      name: "idVerification.passport.number",
                      floating: true,
                    },
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.idVerification.passport.number,
                          expression: "form.idVerification.passport.number",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: {
                        name: "documentNumber",
                        type: "text",
                        placeholder: " ",
                      },
                      domProps: {
                        value: _vm.form.idVerification.passport.number,
                      },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.form.idVerification.passport,
                            "number",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.form.idVerification.documentType === "license"
              ? _c(
                  "FormGroup",
                  {
                    attrs: {
                      "error-container": _vm.errorContainerName,
                      label: "Licence Number",
                      name: "idVerification.license.number",
                      floating: true,
                    },
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.idVerification.license.number,
                          expression: "form.idVerification.license.number",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: {
                        name: "documentNumber",
                        type: "text",
                        placeholder: " ",
                      },
                      domProps: {
                        value: _vm.form.idVerification.license.number,
                      },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.form.idVerification.license,
                            "number",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]
                )
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            class: `col-md-${
              _vm.form.idVerification.documentType === "passport" ? 6 : 4
            }`,
          },
          [
            _vm.form.idVerification.documentType === "passport"
              ? _c("CountrySelect", {
                  attrs: {
                    "error-container": _vm.errorContainerName,
                    name: "idVerification.passport.country",
                    floating: true,
                  },
                  model: {
                    value: _vm.form.idVerification.passport.country,
                    callback: function ($$v) {
                      _vm.$set(_vm.form.idVerification.passport, "country", $$v)
                    },
                    expression: "form.idVerification.passport.country",
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.form.idVerification.documentType === "license"
              ? _c("StateSelect", {
                  attrs: {
                    "error-container": _vm.errorContainerName,
                    name: "idVerification.license.state",
                    floating: true,
                  },
                  model: {
                    value: _vm.form.idVerification.license.state,
                    callback: function ($$v) {
                      _vm.$set(_vm.form.idVerification.license, "state", $$v)
                    },
                    expression: "form.idVerification.license.state",
                  },
                })
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _vm.form.idVerification.documentType === "license"
          ? _c(
              "div",
              { staticClass: "col-md-4" },
              [
                _c("FormGroup", {
                  attrs: {
                    "error-container": _vm.errorContainerName,
                    name: "idVerification.license.cardNumber",
                    floating: true,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function ({ id }) {
                          return [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value:
                                    _vm.form.idVerification.license.cardNumber,
                                  expression:
                                    "form.idVerification.license.cardNumber",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: {
                                id: id,
                                name: "licenseCardNumber",
                                type: "text",
                                placeholder: " ",
                              },
                              domProps: {
                                value:
                                  _vm.form.idVerification.license.cardNumber,
                              },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.form.idVerification.license,
                                    "cardNumber",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass:
                                  "col-form-label d-flex align-items-center gap-1",
                                attrs: { for: id },
                              },
                              [
                                _vm._v("\n            Licence Card Number "),
                                _c("HelpIcon", {
                                  attrs: {
                                    "selected-state":
                                      _vm.form.idVerification.license.state,
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    467175232
                  ),
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("Checkbox", {
        attrs: {
          "error-container": _vm.errorContainerName,
          name: "agreeIdCheck",
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ onClick }) {
              return [
                _c("div", { on: { click: onClick } }, [
                  _vm._v(
                    "\n        I agree to have my identity information verified with the Issuer or Official Record Holder.\n      "
                  ),
                ]),
              ]
            },
          },
        ]),
        model: {
          value: _vm.form.agreeIdCheck,
          callback: function ($$v) {
            _vm.$set(_vm.form, "agreeIdCheck", $$v)
          },
          expression: "form.agreeIdCheck",
        },
      }),
      _vm._v(" "),
      _vm._t("controls", null, null, { prev: _vm.onPrev, next: _vm.onNext }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }